export default import.meta.ROLLDOWN_FILE_URL_ng1OWYlD2DWxm1PjJnipgQ